module.exports = __webpack_public_path__ + "static/media/settings.43fe4184.jpg";